export default __webpack_public_path__ + "static/media/memphis-market-segmentation-and-targeted-advertising.35b52e45.png";